import { render, staticRenderFns } from "./dev-container-of-panel.vue?vue&type=template&id=d2c2e68c"
import script from "./dev-container-of-panel.vue?vue&type=script&lang=js"
export * from "./dev-container-of-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports